import { render, staticRenderFns } from "./CustodianBankIndex.vue?vue&type=template&id=69f6d5ed&"
import script from "./CustodianBankIndex.vue?vue&type=script&lang=js&"
export * from "./CustodianBankIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports